import { useAppContext } from '@/components/utilities/AppContext';
import ComponentsRender from '@/components/ComponentsRender';
import { GLOSSARY } from '@/components/components';
import { getGlossaryRootForLocale } from '@/utils/glossary-routes';

import GlossaryBreadcrumb from './GlossaryBreadcrumb';
import GlossaryHero from './GlossaryHero';
import GlossarySidebar from './GlossarySidebar';

const GLOSSARY_ROOT_LABELS = {
  cs: 'Slovník pojmů',
  en: 'Glossary',
  pl: 'Słownik pojęć'
};

const getGlossaryRootLink = (locale) => {
  const root = getGlossaryRootForLocale(locale);
  return locale === 'cs' ? root : `/${locale}${root}`;
};

const GlossaryDetailPage = () => {
  const { glossaryTerm, locale } = useAppContext();

  if (!glossaryTerm) return null;

  const content = glossaryTerm.content || [];
  const glossaryRootLabel = GLOSSARY_ROOT_LABELS[locale] || GLOSSARY_ROOT_LABELS.cs;
  const glossaryRootLink = getGlossaryRootLink(locale);

  return (
    <section className="glossary-content text-grey-900 bg-white">
      <div className="mx-auto w-[90vw] pt-28 pb-4 xl:w-(--container-width) xl:pt-32">
        <GlossaryBreadcrumb
          glossaryRootPath={glossaryRootLink}
          glossaryRootLabel={glossaryRootLabel}
          termTitle={glossaryTerm.title}
        />
      </div>

      <div className="mx-auto w-[90vw] xl:w-(--container-width)">
        <GlossaryHero
          title={glossaryTerm.title}
          perex={glossaryTerm.shortDescription}
          categories={glossaryTerm.categories || []}
          eyebrow={glossaryRootLabel}
        />
      </div>

      <div className="mx-auto w-[90vw] pt-12 pb-20 xl:w-(--container-width)">
        <div className="grid grid-cols-1 gap-10 xl:grid-cols-[1fr_320px] xl:gap-14">
          <main className="flex min-w-0 flex-col gap-8">
            {content.map((component) => (
              <ComponentsRender key={`${component.id}_${component.__typename}`} type={GLOSSARY} component={component} />
            ))}
          </main>

          <GlossarySidebar
            content={content}
            sidebarCta={glossaryTerm.sidebarCta}
            relatedTerms={glossaryTerm.relatedTerms}
            locale={locale}
          />
        </div>
      </div>
    </section>
  );
};

export default GlossaryDetailPage;
